import { render } from "./OrderEditorModal.vue?vue&type=template&id=f9c95376&scoped=true"
import script from "./OrderEditorModal.vue?vue&type=script&lang=js"
export * from "./OrderEditorModal.vue?vue&type=script&lang=js"

import "./OrderEditorModal.vue?vue&type=style&index=0&id=f9c95376&scoped=true&lang=css"

import exportComponent from "G:\\dev\\OSPanel\\domains\\arenda-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f9c95376"]])

export default __exports__